import { useMemo } from "react";

import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	adultNum: number;
	kidsNum?: number;
};

export const BasicInfoPeopleOfPrintComposition = ({ adultNum, kidsNum }: Props) => {
	const totalPeopleText = useMemo(() => {
		let totalPeople = `大人${adultNum}人`;
		if (!kidsNum) return totalPeople;

		/**
		 * @todo 子どもの年齢と添い寝の人数を追加する
		 */
		totalPeople += `、子ども${kidsNum}人`;

		return totalPeople;
	}, [adultNum, kidsNum]);

	return <PrintBasicInfoTableLayout title="人数" content={totalPeopleText} />;
};
